module.exports = __webpack_public_path__ + "img/LOA Explained Through a Personal Check_150ppi.a7775020.png";